import DialogModal from "./DialogModal";

export default DialogModal;